import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-dash-report-company',
  templateUrl: './report-dash-report-company.component.html',
  styleUrls: ['./report-dash-report-company.component.css']
})
export class ReportDashReportCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
